import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

export interface State {
  sidebarDialogShow:Boolean,
  showDialog: Boolean,
  formDialog:String,
  formSidebarDialog:String,
  options:any,
  titleDialog:string,
  subtitleDialog:string,
  fullDialogShow:boolean,
}

const defaultState: State = {
  sidebarDialogShow:false,
  showDialog: false,
  formDialog:'lfs-forms-none-form',
  formSidebarDialog:'lfs-filters-filters-index',
  options:null,
  titleDialog:'',
  subtitleDialog: '',
  fullDialogShow:false,
}

const getters = {
  fullDialogShow: (state: State) => state.fullDialogShow,
  sidebarDialogShow: (state: State) => state.sidebarDialogShow,
  titleDialog: (state: State) => state.titleDialog,
  subtitleDialog: (state: State) => state.subtitleDialog,
  formDialog: (state: State) => state.formDialog,
  formSidebarDialog: (state: State) => state.formSidebarDialog,
  GetSidebarDialogShow(state:State){
    return state.sidebarDialogShow
  },
  GetFormSidebarDialog(state:State){
    return state.formSidebarDialog
  }
}

const mutations: MutationTree<State> = {
  SetSidebarDialogShow(state:State, payload:Boolean){
    state.sidebarDialogShow = payload
  },
  SetFormSidebarDialog(state:State, payload:String){
    state.formSidebarDialog = payload
  },
  SetFullDialogShow(state:State, payload:any){
    state.fullDialogShow = payload
  },
  SetTitleDialog(state:State, payload:string){
    state.titleDialog = payload
  },
  SetSubtitleDialog(state:State, payload:string){
    state.subtitleDialog = payload
  },
  SetFormSDialog(state:State, payload:string){
    state.formDialog = payload
  }

}

const actions: ActionTree<State, RootState> = {}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
